import {Input} from 'antd'
import classNames from 'classnames'
import {createValue} from 'components/form/utils'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {NullAsDefault, renderSelf} from 'views/Shared'
import {lookup_lookupInfoByValue_Api} from '../../apis'
import useAsyncAction from '../../modules/asyncCache/useAsyncAction'
import {renderIfElse} from '../../views/Shared'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {FaAddressCard, FaLink, FaRegAddressCard, FaRegCircleCheck} from "react-icons/fa6";
import {RiSearch2Line} from "react-icons/ri";
import {bindQueryParams} from "../../views/AppLocals/functions/routerHelper";

const IdentifierCodeLookupField = ({
    name,
    auto = false,
    handleApply,
    defaultValue,
    onChange = NullAsDefault,
    disabled = false,
    getValue = renderSelf,
    placeholder = 'ex: identifier code',
    className,
    params = {search_type: "user", input_type: "identifier_code"}
}) => {
    const t = useTranslate()
    const [autoExec, setAutoExec] = useState(auto)
    const [applyStatus, setApplyStatus] = useState(!!defaultValue)
    const [fieldValue, setFieldValue] = useState(defaultValue)
    const [validInfo, setValidInfo] = useState()
    const {isSm} = useContext(LayoutContext)

    const {
        response,
        success,
        handleAsyncAction: lookupIdentifierCodeGetInfo,
    } = useAsyncAction({
        apiInfo: lookup_lookupInfoByValue_Api,
        values: {owner_type: params?.owner_type, owner_id: params?.owner_id},
        query: bindQueryParams([
            {search_type: params?.search_type},
            {input_type: params?.input_type}
        ]),
    })

    useEffect(() => {
        if (success) {
            const userInfo = _.get(response, 'data', {})
            setValidInfo(userInfo)
            if (!!autoExec) {
                handleApply({...userInfo, fieldValue})
            }
        } else {
            setValidInfo({})
            if (!!autoExec) {
                handleApply({fieldValue})
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [success, response])
    useEffect(() => {
        if (!!defaultValue) {
            lookupIdentifierCodeGetInfo({}, {input_value: defaultValue})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue])

    const prefix = useMemo(() =>
        renderIfElse(
            fieldValue,
            renderIfElse(
                validInfo,
                <FaAddressCard size={16} className="text-green-600"/>,
                <FaRegAddressCard size={16} className="text-blue-600"/>
            ),
            <FaAddressCard size={16} className="text-color-500"/>
        ),
        [fieldValue, validInfo]
    )

    return (
        <div>
            <Input.Search
                name={name}
                prefix={prefix}
                allowClear={true}
                disabled={disabled}
                onChange={onChange}
                defaultValue={getValue(defaultValue)}
                placeholder={_.isString(placeholder) ? t(placeholder) : undefined}
                className={classNames('w-full custom-input-search', className)}
                onSearch={(value) => {
                    if (fieldValue !== value) {
                        onChange(createValue(name, value))
                        if (!!value) {
                            lookupIdentifierCodeGetInfo({}, {input_value: value})
                            setApplyStatus(false)
                        }
                        setFieldValue(value)
                    }
                }}
                enterButton={
                    renderIfElse(
                        !!fieldValue,
                        renderIfElse(
                            validInfo?.name,
                            renderIfElse(
                                !applyStatus,
                                <FaLink
                                    onClick={() => {
                                        handleApply({...validInfo, identifier_code: fieldValue});
                                        setApplyStatus(!_.isEmpty(validInfo) && true);
                                    }}
                                    size={14}
                                    className="hover:opacity-85 cursor-pointer"
                                />,
                                <FaRegCircleCheck/>
                            ),
                            <RiSearch2Line
                                onClick={() => {
                                    handleApply({...validInfo, identifier_code: fieldValue});
                                }}
                                size={14}
                                className="hover:opacity-85 cursor-pointer"
                            />
                        ),
                        <RiSearch2Line
                            onClick={() => {
                                handleApply({...validInfo, identifier_code: fieldValue});
                            }}
                            size={14}
                            className="hover:opacity-85 cursor-pointer"
                        />
                    )
                }
            />
            <div className="mt-2 px-1 flex space-x-1 items-center justify-between">
                {renderIfElse(
                    fieldValue,
                    renderIfElse(
                        validInfo?.name,
                        renderIfElse(
                            applyStatus === true,
                            <span className="flex items-center font-semibold text-sm text-green-600 italic">
                                <FaLink size={12} className="text-green-300 mr-1"/>
                                {t('linked')}
                            </span>,
                            <span className="space-x-1 text-xs italic">
                                <span className="text-color-500">
                                    {`* ${t('this identifier is linked to the account')} : `}
                                </span>
                                <span className="font-bold text-primary">
                                    {validInfo?.name}
                                </span>
                            </span>
                        ),
                        <div className="text-xs text-color-500 italic leading-tight">
                            {`* ${t('not found id code description')}`}
                        </div>
                    ),
                    <span className="text-xs text-color-500 italic">
                        {`* ${t('enter id code')}`}
                    </span>
                )}
            </div>
        </div>
    )
}

export default IdentifierCodeLookupField
